import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Shield } from 'lucide-react';

const COOKIE_CONSENT_KEY = 'cookie_consent';

export function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({ analytics: true, ts: new Date().toISOString() }));
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({ analytics: false, ts: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] bg-card border-t border-border shadow-lg animate-fade-in">
      <div className="max-w-4xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-3">
        <Shield className="w-5 h-5 text-primary shrink-0 mt-0.5 sm:mt-0" />
        <div className="flex-1 min-w-0">
          <p className="text-sm text-foreground font-medium">Cookie- og privatlivspolitik</p>
          <p className="text-xs text-muted-foreground mt-0.5">
            Vi bruger nødvendige cookies for at systemet fungerer. Analytiske cookies hjælper os med at forbedre oplevelsen. 
            Du kan altid ændre dine præferencer under din profil.
          </p>
        </div>
        <div className="flex gap-2 shrink-0">
          <Button variant="outline" size="sm" onClick={handleDecline} className="text-xs">
            Kun nødvendige
          </Button>
          <Button size="sm" onClick={handleAccept} className="text-xs">
            Acceptér alle
          </Button>
        </div>
      </div>
    </div>
  );
}
